import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { take } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ValidationErrors } from '@angular/forms';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { setUnsavedZipFiltersAction } from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-zip',
  templateUrl: './filter-v2-zip.component.html',
  styleUrls: ['./filter-v2-zip.component.scss', '../filters-v2.component.scss'],
})
export class FilterV2ZipComponent implements OnInit {
  @Input() mobile = false;
  @Output() applyFilters = new EventEmitter();
  @ViewChild('trigger') menuTrigger!: MatMenuTrigger;

  protected isOpen = false;
  protected isActive = false;

  public zipCode: string | null = null;
  protected errors?: ValidationErrors;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loadInitialValue();

    // for loading the first time
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.zipCode?.eq) {
          this.zipCode = filters.zipCode.eq;
        } else {
          this.zipCode = null;
        }
        this.checkIsActive();
      });

    // for clearing the filters
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (!filters?.zipCode || !filters.zipCode.eq) {
          this.zipCode = null;
        }
        this.checkIsActive();
      });
  }

  handleChange() {
    if (this.zipCode && this.zipCode.length === 5) {
      this.errors = undefined;
      this.store.dispatch(setUnsavedZipFiltersAction({ eq: this.zipCode }));
      if (!this.mobile) this.applyFilters.emit();
      return;
    }

    const errors = this.hasError();
    if (errors) return;

    this.checkIsActive();
    this.store.dispatch(setUnsavedZipFiltersAction({ eq: undefined }));
    if (!this.mobile) this.applyFilters.emit();
  }

  hasError() {
    if (this.zipCode && this.zipCode.length > 0 && this.zipCode.length < 5) {
      this.errors = { pattern: true, patternError: 'Enter a valid zip code' };
      return true;
    } else {
      this.errors = undefined;
      return false;
    }
  }

  loadInitialValue() {
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.zipCode?.eq) {
          this.zipCode = filters.zipCode.eq;
        } else {
          this.zipCode = null;
        }
      });
  }

  selectAll(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    input.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    input.select();
  }

  resetZipCode() {
    this.zipCode = null;
    this.handleChange();
  }

  closeMenu() {
    this.menuTrigger.closeMenu();
  }

  onMenuClose() {
    this.loadInitialValue();
    this.handleChange();
  }

  checkIsActive() {
    this.isActive = this.zipCode !== null && this.zipCode.length === 5;
  }
}
